<div *ngIf="toolTipData.ciType === ciTypes.Test">
    <div>
        <table>
            <tbody>
                <tr *ngIf="toolTipData.compound && toolTipData.compound !== ' '">
                    <th id="technical-description-name-label">{{'vbeiCompound' | translate}}</th>
                    <td id="technical-description-name-value" [innerHTML]="toolTipData.compound">
                    </td>

                </tr>
                <tr *ngIf="toolTipData.compendium">
                    <th id="technical-description-name-label">{{'vbeiCompendium' | translate}}</th>
                    <td id="technical-description-name-value" [innerHTML]="toolTipData.compendium">
                    </td>
                </tr>
                <tr>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div *ngIf="toolTipData.ciType === ciTypes.Package">
    <div>
        <table>
            <tbody>
                <tr *ngIf="toolTipData.compound && toolTipData.compound !== ' '">
                    <th id="technical-description-name-label">{{'vbeiCompound' | translate}}</th>
                    <td id="technical-description-name-value" [innerHTML]="toolTipData.compound">
                    </td>

                </tr>
                <tr *ngIf="toolTipData.compendium && toolTipData.compendium !== ' '">
                    <th id="technical-description-name-label">{{'vbeiCompendium' | translate}}</th>
                    <td id="technical-description-name-value" [innerHTML]="toolTipData.compendium">
                    </td>
                </tr>
                <tr>
                    <th id="technical-Package-Contains-label">{{'vbeiPackageTests' | translate}}</th>
                    <td id="technical-Package-Contains-value">
                        <ng-container *ngFor="let test of toolTipData.tests; index as i">
                            <div>
                                <span class="head-bold" [innerHTML]="'[' + test.code + ']'"></span>
                                &nbsp;
                                <span [innerHTML]="test.localisedName"></span>
                            </div>
                        </ng-container>
                    </td>
                </tr>
                <tr>
                </tr>
            </tbody>
        </table>
    </div>
</div>